__turbopack_context__.v({
  "message": "rug6Pq_message",
  "message__icon": "rug6Pq_message__icon",
  "notifications-list__item": "rug6Pq_notifications-list__item",
  "notifications-list__item--indicator": "rug6Pq_notifications-list__item--indicator",
  "notifications-list__item-content": "rug6Pq_notifications-list__item-content",
  "notifications-list__item-content--interactive": "rug6Pq_notifications-list__item-content--interactive",
  "notifications-list__item-details": "rug6Pq_notifications-list__item-details",
  "notifications-list__item-message": "rug6Pq_notifications-list__item-message",
  "notifications-list__item-message-container": "rug6Pq_notifications-list__item-message-container",
  "notifications-list__item-message-container__item-message-container-wrapper": "rug6Pq_notifications-list__item-message-container__item-message-container-wrapper",
  "notifications-list__item-message-image": "rug6Pq_notifications-list__item-message-image",
  "notifications-list__item-message-time": "rug6Pq_notifications-list__item-message-time",
  "notifications-list__item-title": "rug6Pq_notifications-list__item-title",
  "notifications-list__url-icon": "rug6Pq_notifications-list__url-icon",
  "notifications-list__url-icon__icon": "rug6Pq_notifications-list__url-icon__icon",
  "show-more-button": "rug6Pq_show-more-button",
  "visually-hidden": "rug6Pq_visually-hidden",
});
